import { Component, inject } from '@angular/core';
import { Router, RouterLink, RouterLinkActive } from '@angular/router';
import { CommonService } from '../../services/common.service';
import { AuthService } from '../../modules/auth/services/auth.service';
import { Popover } from 'primeng/popover';
import { Button } from 'primeng/button';

@Component({
  selector: 'app-top-bar',
  imports: [RouterLink, Popover, Button, RouterLinkActive],
  templateUrl: './top-bar.component.html',
  styleUrl: './top-bar.component.scss',
})
export class TopBarComponent {
  commonService = inject(CommonService);
  authService = inject(AuthService);
  router = inject(Router);

  get isLoggedIn() {
    return this.authService.loginDisplay;
  }

  logout() {
    this.authService.logout();
  }
}
